// industryData.js

export interface IndustryColorData {
    "header-variant": string;
    "usecase-color": string;
    "stroke-color": string;
    "chip-bg": string;
    "chip-border": string;
    "chip-text": string;
    "image-link": string;
    "blue-icon": string;
    "white-icon": string;
    "og-image": string;
}

export interface IndustryJsonData {
    [key: string]: IndustryColorData;
}

export const industries = ["Real Estate", "Education", "Travel", "Healthcare", "Wellness", "Finance", "Automotive", "HR/Recruitment", "Government", "E-commerce/D2C"];
export type Industry = (typeof industries)[number];

export const useCasesData = [
    "Appointment & rescheduling",
    "Lead qualification",
    "Broadcast & bulk messaging",
    "Lead nurturing",
    "Welcome messages",
    "Customer engagement",
    "Payments & reminders",
    "Customer support & FAQs",
    "Orders & updates",
    "Event invites",
];
export const industryColorData: IndustryJsonData = {
    "Real Estate": {
        "header-variant": "linear-gradient(180deg, #FFFAF0 0%, #FFF 100%)",
        "usecase-color": "#FFFAF0",
        "stroke-color": "#ED8936",
        "chip-bg": "#FEEBCB",
        "chip-border": "#FBD38D",
        "chip-text": "#9C4221",
        "image-link": "https://assets.gallabox.com/gb-home/programmatic_seo/header-images/real-estate.png",
        "blue-icon": "https://assets.gallabox.com/gb-home/programmatic_seo/industry-icons/real-estate-blue.svg",
        "white-icon": "https://assets.gallabox.com/gb-home/programmatic_seo/industry-icons/real-estate-logo.svg",
        "og-image": "https://assets.gallabox.com/gb-home/programmatic_seo/og-images/real-estate.png",
    },
    Education: {
        "header-variant": "linear-gradient(180deg, #EBF8FF 0%, #FFF 100%)",
        "usecase-color": "#EBF8FF",
        "stroke-color": "#4299E1",
        "chip-bg": "#BEE3F8",
        "chip-border": "#BEE3F8",
        "chip-text": "#2C5282",
        "image-link": "https://assets.gallabox.com/gb-home/programmatic_seo/header-images/education.png",
        "blue-icon": "https://assets.gallabox.com/gb-home/programmatic_seo/industry-icons/education-blue.svg",
        "white-icon": "https://assets.gallabox.com/gb-home/programmatic_seo/industry-icons/education-logo.svg",
        "og-image": "https://assets.gallabox.com/gb-home/programmatic_seo/og-images/education.png",
    },
    Travel: {
        "header-variant": "linear-gradient(180deg, #F6FFE9 0%, #FFF 100%)",
        "usecase-color": "#F6FFE9",
        "stroke-color": "#8CC438",
        "chip-bg": "#F0FFDB",
        "chip-border": "#D8F0B3",
        "chip-text": "#598615",
        "image-link": "https://assets.gallabox.com/gb-home/programmatic_seo/header-images/travel.png",
        "blue-icon": "https://assets.gallabox.com/gb-home/programmatic_seo/industry-icons/travel-blue.svg",
        "white-icon": "https://assets.gallabox.com/gb-home/programmatic_seo/industry-icons/travel-logo.svg",
        "og-image": "https://assets.gallabox.com/gb-home/programmatic_seo/og-images/travel.png",
    },
    Healthcare: {
        "header-variant": "linear-gradient(180deg, #FFF5F7 0%, #FFF 100%)",
        "usecase-color": "#FFF5F7",
        "stroke-color": "#ED64A6",
        "chip-bg": "#FED7E2",
        "chip-border": "#FBB6CE",
        "chip-text": "#97266D",
        "image-link": "https://assets.gallabox.com/gb-home/programmatic_seo/header-images/health-care.png",
        "blue-icon": "https://assets.gallabox.com/gb-home/programmatic_seo/industry-icons/health-care-blue.svg",
        "white-icon": "https://assets.gallabox.com/gb-home/programmatic_seo/industry-icons/health-care-logo.svg",
        "og-image": "https://assets.gallabox.com/gb-home/programmatic_seo/og-images/health-care.png",
    },
    Wellness: {
        "header-variant": "linear-gradient(180deg, #FAF5FF 0%, #FFF 100%)",
        "usecase-color": "#FAF5FF",
        "stroke-color": "#9F7AEA",
        "chip-bg": "#E9D8FD",
        "chip-border": "#D6BCFA",
        "chip-text": "#553C9A",
        "image-link": "https://assets.gallabox.com/gb-home/programmatic_seo/header-images/wellness.png",
        "blue-icon": "https://assets.gallabox.com/gb-home/programmatic_seo/industry-icons/wellness-blue.svg",
        "white-icon": "https://assets.gallabox.com/gb-home/programmatic_seo/industry-icons/wellness-logo.svg",
        "og-image": "https://assets.gallabox.com/gb-home/programmatic_seo/og-images/wellness.png",
    },
    Finance: {
        "header-variant": "linear-gradient(180deg, #FFFFF0 0%, #FFF 100%)",
        "usecase-color": "#FFFFF0",
        "stroke-color": "#ECC94B",
        "chip-bg": "#FEFCBF",
        "chip-border": "#FAF089",
        "chip-text": "#975A16",
        "image-link": "https://assets.gallabox.com/gb-home/programmatic_seo/header-images/finance.png",
        "blue-icon": "https://assets.gallabox.com/gb-home/programmatic_seo/industry-icons/finance-blue.svg",
        "white-icon": "https://assets.gallabox.com/gb-home/programmatic_seo/industry-icons/finance-logo.svg",
        "og-image": "https://assets.gallabox.com/gb-home/programmatic_seo/og-images/finance.png",
    },
    Automotive: {
        "header-variant": "linear-gradient(180deg, #FFF5F5 0%, #FFF 100%)",
        "usecase-color": "#FFF5F5",
        "stroke-color": "#F56565",
        "chip-bg": "#FED7D7",
        "chip-border": "#FEB2B2",
        "chip-text": "#9B2C2C",
        "image-link": "https://assets.gallabox.com/gb-home/programmatic_seo/header-images/automotive.png",
        "blue-icon": "https://assets.gallabox.com/gb-home/programmatic_seo/industry-icons/automotive-blue.svg",
        "white-icon": "https://assets.gallabox.com/gb-home/programmatic_seo/industry-icons/automotive-logo.svg",
        "og-image": "https://assets.gallabox.com/gb-home/programmatic_seo/og-images/automotive.png",
    },
    "HR/Recruitment": {
        "header-variant": "linear-gradient(180deg, #F0FFF4 0%, #FFF 100%)",
        "usecase-color": "#F0FFF4",
        "stroke-color": "#48BB78",
        "chip-bg": "#C6F6D5",
        "chip-border": "#9AE6B4",
        "chip-text": "#276749",
        "image-link": "https://assets.gallabox.com/gb-home/programmatic_seo/header-images/hr-recruitement.png",
        "blue-icon": "https://assets.gallabox.com/gb-home/programmatic_seo/industry-icons/hr-recruitement-blue.svg",
        "white-icon": "https://assets.gallabox.com/gb-home/programmatic_seo/industry-icons/hr-recruitement-logo.svg",
        "og-image": "https://assets.gallabox.com/gb-home/programmatic_seo/og-images/hr-recruitement.png",
    },
    Government: {
        "header-variant": "linear-gradient(180deg, #E6FFFA 0%, #FFF 100%)",
        "usecase-color": "#E6FFFA",
        "stroke-color": "#38B2AC",
        "chip-bg": "#B2F5EA",
        "chip-border": "#81E6D9",
        "chip-text": "#285E61",
        "image-link": "https://assets.gallabox.com/gb-home/programmatic_seo/header-images/government.png",
        "blue-icon": "https://assets.gallabox.com/gb-home/programmatic_seo/industry-icons/government-blue.svg",
        "white-icon": "https://assets.gallabox.com/gb-home/programmatic_seo/industry-icons/government-logo.svg",
        "og-image": "https://assets.gallabox.com/gb-home/programmatic_seo/og-images/government.png",
    },
    "E-commerce/D2C": {
        "header-variant": "linear-gradient(180deg, #EDFDFD 0%, #FFF 100%)",
        "usecase-color": "#EDFDFD",
        "stroke-color": "#0BC5EA",
        "chip-bg": "#C4F1F9",
        "chip-border": "#9DECF9",
        "chip-text": "#0987A0",
        "image-link": "https://assets.gallabox.com/gb-home/programmatic_seo/header-images/ecommerce.png",
        "blue-icon": "https://assets.gallabox.com/gb-home/programmatic_seo/industry-icons/ecommerce-blue.svg",
        "white-icon": "https://assets.gallabox.com/gb-home/programmatic_seo/industry-icons/ecommerce-logo.svg",
        "og-image": "https://assets.gallabox.com/gb-home/programmatic_seo/og-images/ecommerce.png",
    },
};
